define([
    "csi/access/_base",
    "csi/access/access",
    "csi/access/full",
    "csi/access/readOnly"
], function(csiAccess,access,full,readOnly) {

	var inspectionLibraryAdminRoles = ['Inspection Library Administrator'];
	var inspectionAdminRoles = inspectionLibraryAdminRoles.concat(['Inspection Administrator']);
	var inspectionPlannerRoles = inspectionAdminRoles.concat(['Inspection Planner']);
	var securityGroupAdminRoles = ['Security Group Administrator'];

	csiAccess.addViewRoles({
		"_CS_Data":{
			"AcceptanceLimits": {
				"NewAcceptanceLimit":access(full(inspectionLibraryAdminRoles))
			},
			"InspectionDefects": {
				"NewDefect":access(full(inspectionLibraryAdminRoles))
			},
			"Inspections": {
				"NewFinalInspection":access(full(inspectionPlannerRoles)),
				"NewFinalInspectionsFromStyles":access(full(inspectionPlannerRoles)),
				"NewFinalInspectionsFromPOLines":access(full(inspectionPlannerRoles)),
				"NewFinalInspectionsFromShipments":access(full(inspectionPlannerRoles))
			},
			"InspectionSecurityGroups": {
				"NewFinalInspectionSecurityGroup":access(full(securityGroupAdminRoles))
			},
			"InspectionTestSpecs": {
				"NewInspectionTestSpec":access(full(inspectionLibraryAdminRoles))
			},
			"InspectionErrorTypes": {
				"NewInspectionErrorType":access(full(inspectionLibraryAdminRoles))
			},
			"SamplingPlans": {
				"NewSamplingPlan":access(full(inspectionLibraryAdminRoles))
			},
			"InspectionTemplates": {
				"NewFinalInspectionTemplate":access(full(inspectionLibraryAdminRoles))
			}
		}
	});
});